export default "/images/a961f01d99d34a0fc416ca88ccb2c18c.avif";